import { render, staticRenderFns } from "./mNewsList.vue?vue&type=template&id=2343b77c&scoped=true&"
import script from "./mNewsList.vue?vue&type=script&lang=js&"
export * from "./mNewsList.vue?vue&type=script&lang=js&"
import style0 from "./mNewsList.vue?vue&type=style&index=0&id=2343b77c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2343b77c",
  null
  
)

export default component.exports